import { observer } from "mobx-react-lite";

import { useSportClubsPageState } from "./page.state";
import { SportClubsPageView } from "./page.view";

export const SportClubsPage = observer(() => {
  const state = useSportClubsPageState();
  return <SportClubsPageView state={state} />;
});
